import { useSnackbar } from "notistack";
import { VariantType } from "notistack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export const useToast = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const showToast = (
    message: string = "Something went wrong!",
    variant: VariantType = "error",
    anchorOrigin: { vertical: "top"; horizontal: "right" } = {
      vertical: "top",
      horizontal: "right",
    }
  ) => {
    enqueueSnackbar(message, {
      variant,
      anchorOrigin,
      autoHideDuration: 3000,
      action: (key) => (
        <IconButton
          aria-label="close"
          color="inherit"
          onClick={() => closeSnackbar(key)}
        >
          <CloseIcon />
        </IconButton>
      ),
    });
  };

  return { showToast };
};
